import React from "react";

import { SuggestionsProps, useSearch } from "@usereactify/search";

export type SuggestionsPropsType = React.ComponentProps<
  NonNullable<SuggestionsProps["render"]>
>;

export const Suggestions: React.FC<SuggestionsPropsType> = (
  props
) => {
  const { searchTerm, setSearchTerm, submitSearchTerm } = useSearch();
  return (
    <div className="instant-search-suggestions">
      {searchTerm && (
        <>
        {props.suggestions.length > 0 && (
          <h3 className="text-md">Suggestions</h3>
        )}
          <ul>
            {props.suggestions.map((suggestion) => (
              <li onClick={() => submitSearchTerm(suggestion.text)}>
                {suggestion.text}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
